import LoginPage from "@/components/LoginPage";
import DashboardPage from "@/components/DashboardPage";
import SettingsPage from "@/components/SettingsPage";
import LogoutPage from "@/components/LogoutPage";
import ContactsPage from "@/components/ContactsPage";
import CheckUpdatesPage from "@/components/CheckUpdatesPage";
import TestsPage from "@/components/TestsPage";
import NotFoundPage from "@/components/NotFoundPage";
import ArchivePage from "@/components/ArchivePage";
import ChatsPage from "@/components/ChatsPage";
import { UserModel } from "@/models/UserModel";

export const routes = [
    { // Маршруты с авторизацией
        path: '/',
        children: [
            {
                path: '',
                name: 'home',
                component: DashboardPage
            },
            {
                path: 'android_asset/www/index.html',
                name: 'cordova-home',
                component: DashboardPage
            },
            {
                path: 'dashboard',
                name: 'dashboard',
                component: DashboardPage,
            },
            {
                path: 'archive',
                name: 'archive',
                component: ArchivePage
            },
            {
                path: 'settings',
                name: 'settings',
                component: SettingsPage
            },
            {
                path: 'chats',
                name: 'chats',
                component: ChatsPage
            },
        ],
        beforeEnter: async () => {
            if (UserModel.isAuth()) {
                return;
            }
            return '/login';
        }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        beforeEnter: () => {
            if (!UserModel.isAuth()) {
                return;
            }
            return '/';
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: LogoutPage
    },
    {
        path: '/contacts',
        name: 'contacts',
        component: ContactsPage
    },
    {
        path: '/check-updates',
        name: 'check-updates',
        component: CheckUpdatesPage
    },
    {
        path: '/tests',
        name: 'tests',
        component: TestsPage
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'page-not-found',
        component: NotFoundPage
    },
];